/* Two opposite sides of one mug; all name measurements use the fixed print template. */
(() => {
  function enhance(root) {
    if (root.dataset.ready) return;
    const form=root.querySelector('form[id^="AddToCartForm"]');
    const arts=JSON.parse(root.querySelector('[data-mug-art-config]').textContent);
    const layout=JSON.parse(root.querySelector('[data-mug-layout-config]').textContent);
    const blanks=JSON.parse(root.querySelector('[data-mug-blank-config]').textContent);
    const placeholder=JSON.parse(root.querySelector('[data-mug-default-name]').textContent);
    const art=root.querySelector('[data-mug-original-art]'), canvas=root.querySelector('[data-mug-name]');
    const context=canvas.getContext('2d'), half=layout.safe_width/2;
    const flatName=document.createElement('canvas');
    flatName.width=half;flatName.height=layout.safe_height;
    const flatContext=flatName.getContext('2d',{willReadFrequently:true});
    // The product's 82 mm diameter gives the print-space cylinder radius.
    // Project only the preview; the production PNG keeps its flat wrap geometry.
    const surfaceRadius=41*layout.dpi/25.4;
    const name=form.querySelector('#custom-name'), fill=form.querySelector('#fillColorPicker'), stroke=form.querySelector('#strokeColorPicker');
    const fontHidden=form.querySelector('#fontHidden'), fonts=form.querySelector('#fontOptions'), selectedFont=form.querySelector('#selectedFont');
    const fontSelect=form.querySelector('#customFontSelect');
    const projection=1254*.6/half;
    let family=fontHidden.value || 'cooper-black-std';
    function panels() {
      for(const [selector,centre] of [['[data-art-panel]',.6],['[data-name-panel]',.4]]) {
        const panel=root.querySelector(selector);
        Object.assign(panel.style,{width:half+'px',height:layout.safe_height+'px',
          left:(1254*centre-half*projection/2)+'px',top:(1254*.55-layout.safe_height*projection/2)+'px',
          transform:'scale('+projection+')'});
      }
    }
    function resize() {
      root.querySelectorAll('[data-mug-skin]').forEach(skin=>{
        const width=skin.parentElement.clientWidth||400;
        skin.style.transform='scale('+(width/1254)+')';
      });
    }
    function curveNamePreview(bounds) {
      const height=layout.safe_height,centre=half/2;
      const source=flatContext.getImageData(0,0,half,height).data;
      const frame=context.createImageData(half,height),output=frame.data;
      const project=x=>centre+surfaceRadius*Math.sin(Math.max(-Math.PI/2,Math.min(Math.PI/2,(x-centre)/surfaceRadius)));
      const first=Math.max(0,Math.floor(project(bounds.left))-1),last=Math.min(half-1,Math.ceil(project(bounds.right))+1);
      // Inverse-map only the glyph area. One pixel transfer avoids hundreds of
      // canvas draws on each keystroke; premultiplied interpolation keeps edges clean.
      for(let x=first;x<=last;x++) {
        const angle=Math.asin((x+.5-centre)/surfaceRadius),sx=centre+surfaceRadius*angle-.5;
        const ix=Math.floor(sx),fx=sx-ix,lift=40*(Math.cos(angle)-1);
        if(ix<0||ix>=half-1)continue;
        const top=Math.max(0,Math.floor(bounds.top+lift)-1),bottom=Math.min(height-1,Math.ceil(bounds.bottom+lift)+1);
        for(let y=top;y<=bottom;y++) {
          const sy=y-lift,iy=Math.floor(sy),fy=sy-iy;
          if(iy<0||iy>=height-1)continue;
          const a=(iy*half+ix)*4,b=a+4,c=a+half*4,d=c+4;
          const wa=source[a+3]*(1-fx)*(1-fy),wb=source[b+3]*fx*(1-fy),wc=source[c+3]*(1-fx)*fy,wd=source[d+3]*fx*fy;
          const alpha=wa+wb+wc+wd;if(alpha<.5)continue;
          const target=(y*half+x)*4;output[target+3]=Math.round(alpha);
          for(let channel=0;channel<3;channel++)output[target+channel]=(source[a+channel]*wa+source[b+channel]*wb+source[c+channel]*wc+source[d+channel]*wd)/alpha;
        }
      }
      context.putImageData(frame,0,0);canvas.dataset.projection='cylindrical';
    }
    function updateName() {
      const text=name.value.trim()||placeholder;
      form.querySelector('#fillHiddenInput').value=fill.value;
      form.querySelector('#strokeHiddenInput').value=stroke.value;
      root.querySelector('[data-mug-name-text]').textContent=text;
      flatContext.clearRect(0,0,half,layout.safe_height);
      let size=layout.font_size, metrics;
      for(;size>=layout.minimum_font_size;size--) {
        flatContext.font=size+'px '+family;
        metrics=flatContext.measureText(text);
        const width=(metrics.actualBoundingBoxLeft??0)+(metrics.actualBoundingBoxRight??metrics.width)+2*layout.stroke_width;
        const height=(metrics.actualBoundingBoxAscent??size)+(metrics.actualBoundingBoxDescent??0)+2*layout.stroke_width;
        if(width<=layout.name_max_width && height<=layout.safe_height) break;
      }
      canvas.dataset.fontSize=String(size);
      canvas.dataset.font=fontHidden.value;
      const left=metrics.actualBoundingBoxLeft??0,right=metrics.actualBoundingBoxRight??metrics.width;
      const ascent=metrics.actualBoundingBoxAscent??size,descent=metrics.actualBoundingBoxDescent??0;
      const x=(half-(left+right))/2+left,y=(layout.safe_height-(ascent+descent))/2+ascent;
      flatContext.lineWidth=2*layout.stroke_width;flatContext.lineJoin='round';flatContext.strokeStyle=stroke.value;flatContext.fillStyle=fill.value;
      flatContext.strokeText(text,x,y);flatContext.fillText(text,x,y);
      curveNamePreview({left:x-left-layout.stroke_width-2,right:x+right+layout.stroke_width+2,top:y-ascent-layout.stroke_width-2,bottom:y+descent+layout.stroke_width+2});
    }
    function chooseFont(item) {
      if(!item) return;
      fontHidden.value=item.dataset.value;
      family=item.style.fontFamily||item.dataset.value;
      selectedFont.textContent=item.textContent.trim();selectedFont.style.fontFamily=family;
      fontHidden.dispatchEvent(new Event('change',{bubbles:true}));
      updateName();
      if(document.fonts.load)document.fonts.load(layout.font_size+'px '+family).then(updateName);
    }
    function chooseDesign(radio) {
      const key=radio.dataset.illustratedDesign, cfg=arts[key];
      if(!cfg) return;
      form.querySelector('#illustrated-design-code').value=key;
      art.src=cfg.url;art.alt=radio.value;
      const scale=Math.min(1,layout.art_max_width/cfg.width,layout.art_max_height/cfg.height);
      const width=Math.floor(cfg.width*scale),height=Math.floor(cfg.height*scale);
      Object.assign(art.style,{width:width+'px',height:height+'px',left:((half-width)/2)+'px',top:((layout.safe_height-height)/2)+'px'});
      // An illustration change never resizes or redraws the name.
    }
    function chooseColour(radio) {
      root.querySelectorAll('[data-mug-blank]').forEach(image=>image.src=blanks[radio.dataset.illustratedColour]);
    }
    const designs=[...form.querySelectorAll('[data-illustrated-design]')], colours=[...form.querySelectorAll('[data-illustrated-colour]')];
    designs.forEach(input=>input.addEventListener('change',()=>{if(input.checked)chooseDesign(input);}));
    colours.forEach(input=>input.addEventListener('change',()=>{if(input.checked)chooseColour(input);}));
    const requested=new URLSearchParams(window.location.search).get('design');
    const initial=designs.find(r=>r.dataset.illustratedDesign===requested)||designs.find(r=>r.checked)||designs[0];
    if(initial){initial.checked=true;chooseDesign(initial);}
    chooseColour(colours.find(r=>r.checked)||colours[0]);
    selectedFont.addEventListener('click',()=>fonts.classList.toggle('hidden'));
    fonts.addEventListener('click',event=>{const item=event.target.closest('li[data-value]');if(item){chooseFont(item);fonts.classList.add('hidden');}});
    fontSelect.addEventListener('keydown',event=>{
      if(!['ArrowUp','ArrowDown','Escape'].includes(event.key))return;
      event.preventDefault();
      if(event.key==='Escape'){fonts.classList.add('hidden');return;}
      const options=[...fonts.querySelectorAll('li[data-value]')],index=options.findIndex(item=>item.dataset.value===fontHidden.value);
      chooseFont(options[(index+(event.key==='ArrowDown'?1:-1)+options.length)%options.length]);
    });
    document.addEventListener('click',event=>{if(!fontSelect.contains(event.target))fonts.classList.add('hidden');});
    [name,fill,stroke].forEach(input=>input.addEventListener('input',updateName));
    form.querySelectorAll('[data-fill][data-stroke]').forEach(button=>{button.style.color=button.dataset.fill;button.style.webkitTextStroke='2px '+button.dataset.stroke;button.addEventListener('click',()=>{
      fill.value=button.dataset.fill;stroke.value=button.dataset.stroke;updateName();name.dispatchEvent(new Event('input',{bubbles:true}));
    });});
    form.addEventListener('submit',event=>{updateName();if(!name.value.trim()){event.preventDefault();name.focus();}});
    chooseFont([...fonts.querySelectorAll('li[data-value]')].find(item=>item.dataset.value===fontHidden.value)||fonts.querySelector('li[data-value]'));
    let count=0;
    for(const group of form.querySelectorAll(':scope > .product-form__input,.editor-toolbar>.product-form__input')){
      const label=group.querySelector(':scope > .form__label');if(!label||group.querySelector('#custom-message'))continue;
      const step=document.createElement('span');step.className='step';step.setAttribute('aria-hidden','true');step.textContent=String(++count);
      label.prepend(step);label.classList.add('illustrated-mug-step-label');
    }
    const submit=form.querySelector('button[type="submit"]'), assurance=form.querySelector('.atelier-order-assurance');
    if(submit&&assurance)submit.after(assurance);
    const review=form.querySelector('[data-atelier-review]');if(review)review.open=true;
    panels();resize();document.fonts.ready.then(updateName);window.addEventListener('resize',resize);
    root.dataset.ready='true';
  }
  const init=()=>document.querySelectorAll('[data-illustrated-mug]').forEach(enhance);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
